import type { Plan } from '../types/Plan'
import { PlanComparisonFeatures } from './planComparisonData'
import type { HybridPlanData } from './planData'
import { PlanFeatures } from './planData'

export const smbCoreMonitoringPlanData: Plan = {
  freeMonths: 1,
  isDefault: true,
  isResidential: false,
  name: 'Core Business Monitoring',
  pricePerDay: '$1.17',
  pricePerMonth: '$34.99',
  shortName: 'Core Business',
  sku: 'SSEDSM2-SMB__18994653',
  type: 'interactiveSMB'
}

export const smbProMonitoringPlanData: Plan = {
  freeMonths: 1,
  isDefault: true,
  isResidential: false,
  name: 'Pro Business Monitoring',
  pricePerDay: '$2.33',
  pricePerMonth: '$69.99',
  shortName: 'Pro Business',
  sku: 'SSODMONON-SMB__18994692',
  type: 'odmonOvernightSMB'
}

export const smbProPlusMonitoringPlanData: Plan = {
  freeMonths: 1,
  isDefault: false,
  isResidential: false,
  name: 'Pro Plus Business Monitoring',
  pricePerDay: '$3.33',
  pricePerMonth: '$99.99',
  shortName: 'Pro Plus Business',
  sku: 'SSODMON247-SMB__18994702',
  type: 'odmon247SMB'
}

export const businessPlansData = [
  {
    ...smbCoreMonitoringPlanData,
    isDefault: false
  },
  smbProMonitoringPlanData,
  smbProPlusMonitoringPlanData
]

export const businessHybridPlanData: HybridPlanData = {
  'SSEDSM2-SMB__18994653': {
    description: '24/7 professional monitoring by a team of live agents',
    features: [
      {
        feature: PlanFeatures.liveAgents,
        description: (
          <>
            Live agents monitor for emergencies & request fast police dispatch{' '}
            <strong>24/7</strong>
          </>
        )
      },
      {
        feature: PlanFeatures.cameraRecordings,
        description: 'Unlimited video recordings & 30-day storage'
      }
    ],
    comparisonFeatures: new Map([
      [PlanComparisonFeatures.professionalMonitoring, null],
      [PlanComparisonFeatures.multiCamera, null],
      [PlanComparisonFeatures.intruderIntervention, null],
      [PlanComparisonFeatures.videoVerification, null],
      [PlanComparisonFeatures.cameraRecording, null],
      [PlanComparisonFeatures.accessPins, null],
      [PlanComparisonFeatures.appControl, null],
      [PlanComparisonFeatures.cellularConnection, null],
      [PlanComparisonFeatures.noContract, null],
      [PlanComparisonFeatures.customerSupport, null]
    ])
  },
  'SSODMONON-SMB__18994692': {
    description:
      'Core Business + overnight crime prevention with Active Guard Outdoor Protection',
    features: [
      {
        feature: PlanFeatures.allCoreFeatures,
        description: 'All Core Business features'
      },
      {
        feature: PlanFeatures.liveAgents,
        description: (
          <>
            Live agents deter potential intruders using outdoor cameras{' '}
            <strong>overnight (8pm-6am)</strong>
          </>
        )
      }
    ],
    comparisonFeatures: new Map([
      [PlanComparisonFeatures.professionalMonitoring, null],
      [PlanComparisonFeatures.multiCamera, null],
      [
        PlanComparisonFeatures.activeGuard,
        <>
          <span className="block">Available 8pm-6am,</span>
          <span className="block">local time</span>
        </>
      ],
      [PlanComparisonFeatures.intruderIntervention, null],
      [PlanComparisonFeatures.videoVerification, null],
      [PlanComparisonFeatures.cameraRecording, null],
      [PlanComparisonFeatures.accessPins, null],
      [PlanComparisonFeatures.appControl, null],
      [PlanComparisonFeatures.cellularConnection, null],
      [PlanComparisonFeatures.antiTheft, null],
      [PlanComparisonFeatures.noContract, null],
      [PlanComparisonFeatures.customerSupport, null]
    ])
  },
  'SSODMON247-SMB__18994702': {
    description:
      'Core Business + 24/7 crime prevention with Active Guard Outdoor Protection',
    features: [
      {
        feature: PlanFeatures.allCoreFeatures,
        description: 'All Core Business features'
      },
      {
        feature: PlanFeatures.liveAgents,
        description: (
          <>
            Live agents deter potential intruders using outdoor cameras{' '}
            <strong>24/7</strong>
          </>
        )
      }
    ],
    comparisonFeatures: new Map([
      [PlanComparisonFeatures.professionalMonitoring, null],
      [PlanComparisonFeatures.multiCamera, null],
      [
        PlanComparisonFeatures.activeGuard,
        <span className="block">Available 24/7</span>
      ],
      [PlanComparisonFeatures.intruderIntervention, null],
      [PlanComparisonFeatures.videoVerification, null],
      [PlanComparisonFeatures.cameraRecording, null],
      [PlanComparisonFeatures.accessPins, null],
      [PlanComparisonFeatures.appControl, null],
      [PlanComparisonFeatures.cellularConnection, null],
      [PlanComparisonFeatures.antiTheft, null],
      [PlanComparisonFeatures.noContract, null],
      [PlanComparisonFeatures.customerSupport, null]
    ])
  }
}
